
// 物流服务产品
import { mapState } from 'vuex'
import LayoutMixin from '@/mixins/layout'
import Sidebar from './components/-Sidebar.vue'
import JpSidebar from '@/modules/templates/jp/product/components/-Sidebar.vue'
import SupportTop from '@/components/page/support-top.vue'
import JpServiceCards from '@/modules/templates/jp/product/components/JpServiceCards.vue'
import JpBanner from '@/modules/templates/jp/product/components/JpBanner.vue'
import jialiwuliu from '@/assets/img/footer/jialiwuliu.png'
import { isHiddenHeaderFn } from '@/utils/utils'
import { addEventListener, removeEventListener } from '@/utils/queryEle'
import allUrls from '@/utils/config'
import footerConfig from '@/modules/config/footer'

export default {
  components: { SupportTop, Sidebar, JpSidebar, JpServiceCards, JpBanner },
  mixins: [LayoutMixin],
  async asyncData(content) {
    try {
      const { app, route } = content
      const path = route.fullPath.split('?')[0]
      const pathList = path.split('/')
      const detailName = pathList[pathList.length - 1]
      const { result } = await app.$API.product.getLogisticsService()
      let isChildren = false
      let List = []
      let isProduct = false
      let currentProductType = null
      if (route.query.isProduct === 'product') {
        isProduct = true
        // 物流产品
        const productList = result.product
        productList.forEach((item) => {
          item.children.forEach((items) => {
            if (items.code === detailName) {
              currentProductType = item.productType
              if (items.details && items.details.length >= 1) {
                List = items.details
              } else {
                isChildren = true
                List = items.children
              }
            }
          })
        })
        console.log('List----', List)
      } else if (route.query.isProduct === 'increment') {
        // 增值服务
        result.increment.forEach((item) => {
          if (item.code === detailName) {
            List = item.details
          }
        })
      } else {
        result.addition.forEach((item) => {
          if (item.code === detailName) {
            List = item.details
          }
        })
      }
      return {
        isProduct,
        List,
        isChildren,
        currentProductType,
        detailName,
      }
    } catch (e) {
      return {
        isProduct: false,
        List: [],
        isChildren: false,
        currentProductType: null,
        detailName: '',
      }
    }
  },
  data() {
    return {
      jialiwuliu,
      siderList: [],
      nowIndex: 0,
      nowChildIndex: 0,
      il8nName: '',
      il8nShip: 'navs.shipNow',
      searchBarFixed: false,
      isReachBottom: false, // 滚动接近底部时取消tab固定定位
      curHash: '', // 当前页面hash值，匹配右侧详情一级菜单
      offsetBottom: 0, // 无效
      footerHeight: 0,
      klnUrl: '',
      bannerName: '', // 待办！！！！！！！！！！！！！！！！！！！！！！！！！！
      tabHeight: 0,
      currentProductType: null, // 当前产品所属的 productType
      tabStyle: {
        top: '0px',
      },
      initTimer: null,
      handleScrollFunc: null, // 保存事件处理函数引用
    }
  },
  head() {
    const obj = {
      title: this.il8nName + this.$t('navs.suffixName'),
    }
    const key = this.$route.params.detail
    const curHash = this.$route.hash
    this.bannerName = key + curHash
    if (this.isProduct && key !== 'sfbuy') {
      // 为物流产品且不为顺丰集运
      obj.meta = [
        {
          hid: 'description',
          name: 'description',
          content: this.$t(`descriptions.${key}`),
        },
      ]
    }
    return obj
  },
  computed: {
    ...mapState({
      resizeInfo: (state) => state.resizeInfo,
      site: (state) => state.site,
      productMenus: (state) => state.productMenus,
    }),
    // 判断是否需要隐藏公共部分
    isHiddenHeader() {
      return isHiddenHeaderFn(this.$route)
    },
    getBottomOffset() {
      return this.offsetBottom + this.footerHeight + 'px'
    },
    getBottomOffsetChild() {
      return this.offsetBottom + this.footerHeight - 60 + 'px'
    },
    isVn() {
      return this.site === 'vn'
    },
    // 日本站 PC 端：展示全部服务 + 3 个服务卡片
    isJpPc() {
      return this.site === 'jp' && !this.resizeInfo.isMobile
    },
    // 嘉里物流是否展示
    isKlnShow() {
      const initFlag = !this.isHiddenHeader && this.isProduct
      const klnFlag = footerConfig[this.site]?.service
        ?.otherSite(this.lang)
        ?.some((item) => {
          return item.href === this.klnUrl
        })
      console.log(initFlag, klnFlag)
      return initFlag && klnFlag
    },
  },
  watch: {
    curHash(val) {
      if (val) {
        window.location.hash = '#' + val
      }
    },
    productMenus(val) {
      this.queryRoute(this.$route.query.isProduct)
    },
  },
  created() {
    this.queryRoute(this.$route.query.isProduct)
    this.initHash()
  },
  mounted() {
    this.lang = this.$route.params.lang
    const offseHeight = document.querySelector('.footer-wrapper')?.offsetHeight
    this.footerHeight = offseHeight
    this.initTimer = setTimeout(() => {
      this.tabHeight = document.getElementById('tab-ul-pc')?.offsetHeight
      if (!this.isHiddenHeader) {
        const height = document.querySelector('#header')?.offsetHeight
        this.tabStyle = `${height}px`
      }
    }, 0)
    // 使用原生API添加事件监听器，并保存引用
    this.handleScrollFunc = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.handleScrollFunc, { passive: true })
    this.klnUrl = allUrls.klnUrl + '/' + this.lang
  },
  destroyed() {
    // 清理定时器
    if (this.initTimer) {
      clearTimeout(this.initTimer)
      this.initTimer = null
    }
    // 使用原生API移除事件监听器
    if (this.handleScrollFunc) {
      window.removeEventListener('scroll', this.handleScrollFunc)
      this.handleScrollFunc = null
    }
  },
  methods: {
    // 初始化
    initHash() {
      if (process.client) {
        const { hash } = this.$route
        // 双层结构
        if (this.List.some((i) => i.level === 2)) {
          if (this.List.some((o) => '#' + o.code === hash)) {
            this.curHash = this.$route.hash.slice(1)
          } else {
            // 如果没有，默认取第一个
            this.curHash = this.List[0].code
          }
        }
      }
    },
    queryRoute(val) {
      const fullPath = this.$route.fullPath
      const path = fullPath.split('?')[0]
      const pathList = path.split('/')
      const detailName = pathList[pathList.length - 1]
      this.detailName = detailName // 其实就是code，比如fast

      const levelMenu1 = this.productMenus?.find((item) => item.name === val)
      if (!levelMenu1) return
      if (levelMenu1?.hasNext) {
        // 物流产品：日本站按 productType 过滤菜单，其他站点保持原样
        if (this.site === 'jp' && !this.resizeInfo.isMobile) {
          // JP PC：展示全部服务，不按 productType 过滤
          this.siderList = levelMenu1?.children || []
        } else if (this.site === 'jp' && this.currentProductType) {
          // JP H5：保持原有 productType 过滤
          const allChildren = levelMenu1?.children || []
          this.siderList = allChildren.filter(
            child => child.productType === this.currentProductType
          )
        } else {
          this.siderList = levelMenu1?.children
        }
      } else {
        this.siderList = [levelMenu1]
      }
      this.il8nName = this.findNameByCode(this.siderList, detailName)
    },
    findNameByCode(arr, code) {
      let result = ''
      const matched = arr?.find((i) => i.name === code)
      if (matched) {
        // 直接命中
        result = matched?.cname
      } else {
        // 递归调用
        for (const item of arr) {
          if (item?.children) {
            result = this.findNameByCode(item?.children, code)
            if (result) break
          }
        }
      }

      return result
    },
    scrollIntoView(id, type, index) {
      type === 'child' ? (this.nowChildIndex = index) : (this.curHash = index)
      const element = document.getElementById(id)
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      const offsetTop = document.querySelector('.content_wrap')?.offsetTop || 0
      const offseHeight = document.querySelector('.content_wrap')?.offsetHeight || 0

      if (scrollTop > offsetTop) {
        this.searchBarFixed = true

        if (this.isProduct && scrollTop + 160 > offseHeight - offsetTop) {
          // 滚动到底部，左侧菜单和底部重叠
          this.offsetBottom = scrollTop - (offseHeight - offsetTop) + 160
          this.isReachBottom = true
        } else {
          this.offsetBottom = 0
          this.isReachBottom = false
        }
      } else {
        this.searchBarFixed = false
        this.isReachBottom = false
      }
    },
  },
}
